/**
 * check if boost upsell has displayed
 * @param boostCode
 * @param boostUpsellCodes
 */
export const hasBoostUpsellDisplayed = (boostCode: string, boostUpsellCodes: Array<string>) => {
  return boostUpsellCodes.includes(boostCode);
};
